import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import '../../styles/Auth.css';

export default function ForgotPasswordPage() {
  const { forgotPassword } = useAuth();
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email.trim()) {
      setError('Please enter your email.');
      return;
    }
    setSubmitting(true);
    try {
      await forgotPassword(email.trim());
      setDone(true);
    } catch (err) {
      setError(err?.response?.data?.detail || 'Could not send reset email. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page" data-testid="forgot-page">
      <Link to="/login" className="auth-back">&larr; Back to sign in</Link>
      <div className="auth-card">
        <img src="/seal/icraftz-wax-seal-small.png" alt="" className="auth-card-seal" aria-hidden="true" />
        <h1 className="auth-title">Reset your <span className="auth-title-accent">Password</span></h1>
        <p className="auth-sub">We'll send you a fresh seal of access.</p>
        <div className="auth-divider"><span className="auth-divider-line" /><span className="auth-divider-mark">❦</span><span className="auth-divider-line" /></div>

        {done ? (
          <>
            <p className="auth-message auth-message-success" data-testid="forgot-success">
              If an account exists for <strong>{email}</strong>, a reset link is on its way. Check your inbox (and spam) — the link expires in 1 hour.
            </p>
            <p className="auth-footer"><Link to="/login">Back to sign in</Link></p>
          </>
        ) : (
          <form className="auth-form" onSubmit={handleSubmit}>
            <div>
              <p className="auth-field-label">Email</p>
              <input
                type="email"
                className="auth-input"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="forgot-email"
                autoComplete="email"
                required
              />
            </div>
            <button type="submit" className="auth-submit" disabled={submitting} data-testid="forgot-submit">
              {submitting ? 'Sending…' : 'Send Reset Link'}
            </button>
            {error && <p className="auth-message auth-message-error">{error}</p>}
          </form>
        )}

        {!done && (
          <p className="auth-footer">
            Remembered it? <Link to="/login">Sign in</Link>
          </p>
        )}
      </div>
    </div>
  );
}
